module.exports = __webpack_public_path__ + "img/chevron-compact-right.4c48e112.svg";